import { render } from "./Userprofile.vue?vue&type=template&id=99fcdfcc"
import script from "./Userprofile.vue?vue&type=script&lang=js"
export * from "./Userprofile.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__